import { post, patch, get, deletee } from "./index";

export const uploadSitemapFile = (data) => {
  const request = {
    subUrl: `/admin/update-sitemap`,
    data,
  };
  return post(request);
};
